var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconPerson = function SvgIconPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 37,
    viewBox: "0 0 19 37",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15076 6.30363C9.52684 3.20746 13.7889 1.31057 15.8195 1C17.1956 1.91739 16.3929 3.5682 15.8195 3.90266C11.6626 4.47603 9.15415 8.66877 9.5125 9.8155C9.87085 10.9622 14.1711 13.4707 14.7445 13.6857C15.3178 13.9007 18.6864 16.4809 18.3997 18.9893C18.1703 20.9961 14.7206 22.0234 13.0244 22.2862L17.3246 34.1835C16.7512 36.7063 14.84 36.0709 14.0994 35.4019C10.4872 25.8841 9.20194 23.5046 9.01082 23.5046L4.42388 35.4019C2.9188 36.6203 1.65261 35.7842 1.34204 34.6136C2.24987 30.4567 6.14398 20.5804 6.43066 16.6242C6.78901 11.6789 6.43066 10.1739 8.15076 6.30363Z",
    fill: "#FF6B00",
    stroke: "#FF6B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9528 19.4908L13.5978 16.2656C14.5056 16.7673 16.2209 17.9284 15.8196 18.5591C15.4182 19.1898 13.7411 19.443 12.9528 19.4908Z",
    fill: "#F2F2F2",
    stroke: "#FF6B00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.422,
    cy: 8.56163,
    r: 3.04601,
    fill: "#FF6B00"
  })));
};

export default __webpack_public_path__ + "static/media/iconPerson.9d37d78c.svg";
export { SvgIconPerson as ReactComponent };